import React, { useContext } from "react";
import { ConfirmDialog } from "sprint-common-web";

import { useFileRecordApi } from "../../../../../common/api/master-api/file-records/useFileRecordApi";
import { FileRecordListingContext } from "../../context/FileRecordListingContext";

interface RemoveFileRecordListingDialogProps {
    onClose(): void;
    isOpen: boolean;
    itemId: string;
}

export const RemoveFileRecordListingDialog: React.VFC<RemoveFileRecordListingDialogProps> = ({
    onClose,
    isOpen,
    itemId
}: RemoveFileRecordListingDialogProps) => {
    const { removeFileRecord } = useFileRecordApi();

    const { removeFileRecord: removeRecordInContext } = useContext(FileRecordListingContext);

    const handleConfirmation = async () => {
        await removeFileRecord({ fileRecordId: itemId });

        removeRecordInContext(itemId);

        onClose();
    };

    return (
        <ConfirmDialog
            title="Remove file record"
            text="Are you sure you want to remove file record? This action is irreversible."
            hidden={!isOpen}
            confirm={{ onClick: handleConfirmation }}
            cancel={{ onClick: onClose }}
        />
    );
};
